import Vue from 'vue';
import {MediaQueryProvider, MatchMedia} from 'vue-component-media-queries'
import LazyLoad from 'vanilla-lazyload';

import TgpBase from "../components/tgp/TgpBase";
import TgpContent from "../components/tgp/TgpContent";
import TgpLink from "../components/tgp/TgpLink";
import TgpItem from "../components/tgp/TgpItem";
import TgpJoinUrl from "../components/tgp/TgpJoinUrl";
import BackToTop from "../components/util/BackToTop";
import CountDown from '../components/util/CountDown';
import Popup from '../components/util/Popup';

import analytics from '../directives/analytics';
import SvgObserver from "../components/global/SvgObserver";
import Swiper from '../components/util/Swiper';

Vue.component('media-query-provider', MediaQueryProvider);
Vue.component('match-media', MatchMedia);
Vue.component('svgObserver', SvgObserver);

Vue.component('tgp-base', TgpBase);
Vue.component('tgp-content', TgpContent);
Vue.component('tgp-item', TgpItem);
Vue.component('tgp-link', TgpLink);
Vue.component('tgp-join-url', TgpJoinUrl);
Vue.component('back-to-top', BackToTop);
Vue.component('CountDown', CountDown);
Vue.component('Popup', Popup);
Vue.component('Swiper', Swiper);

Vue.directive('analytics', analytics);

const mediaQueries = {
    mobile: '(max-width: 767px)',
    tablet: '(min-width: 768px) and (max-width: 1023px)',
    desktop: '(min-width: 1024px)',
};

window.app = new Vue({
    el: '#vue-app',
    data: {
        variables: window.variables,

        lazyLoad: null,

        storyVolumeIcon: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z',
    },

    methods: {
        deviceChanged() {
            if (this.lazyLoad) {
                // For some reason, nextTick doesn't do the job here
                setTimeout(() => this.lazyLoad.update(), 100);
            }
        },

        // Social TGP
        muteUnmuteStories() {
            let swiper = document.getElementById('stories-tgp-swiper');
            let slide = swiper.querySelector('.swiper-slide-active');
            let video = slide.querySelector('.story-video');

            if (video.muted) {
                video.muted = false;
                localStorage.setItem('storiesVolume', 'yes');
                this.storyVolumeIcon = "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z";
            } else {
                video.muted = true;
                localStorage.setItem('storiesVolume', 'no');
                this.storyVolumeIcon = "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z";
            }
        },

        resetToMuteStories() {
            console.log('resetToMuteStories');
            localStorage.setItem('storiesVolume', 'no');
            this.storyVolumeIcon = "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z";
        },

        playPauseStories() {
            console.log('playPauseStories');
            let button = document.getElementById('story-play-button');
            let swiper = document.getElementById('stories-tgp-swiper');
            let slide = swiper.querySelector('.swiper-slide-active');
            let video = slide.querySelector('.story-video');

            video.play();
            video.muted = true;

            button.style.display = 'none';
            localStorage.setItem('storiesVolume', 'no');
            this.storyVolumeIcon = "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z";
        }
    },

    mediaQueries,

    async mounted() {
        this.lazyLoad = new LazyLoad({
            elements_selector: '.lazy',
        });
    }
});
